import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output
} from '@angular/core'
import { ResourceMode } from '../../../abacus/enums/resource-mode.enum'

@Component({
  selector: 'app-step-progress-bar',
  templateUrl: './step-progress-bar.component.html',
  styleUrls: ['./step-progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class StepProgressBarComponent {
  steps = input.required<Map<number, string>>()
  currentStep = input<number>(0)
  mode = input<ResourceMode>(ResourceMode.Create)

  stepClicked = output<number>()

  protected stepsArray = computed(() =>
    Array.from(this.steps().keys())
  )

  onStepClicked(step: number): void {
    if (step < this.currentStep() || this.mode() === ResourceMode.Edit) {
      this.stepClicked.emit(step)
    }
  }
}
